export default __webpack_public_path__ + "static/media/trash.cdca171c.svg";